import React from 'react'
import EyefinitySectionFields from '../EyefinitySectionFields'

export default function Insured(props) {
  return <EyefinitySectionFields {...props} sectionName="insured" title="Insured" />
}
